import { useState, useRef } from 'react';
import CommonStyles from './FJAiToolsItemCommon.module.less';
import Styles from './FJVideoPlayerPreview.module.less';
import FJLocalStore from '../../../../../../store/FJLocalStore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FJImage from '../../../../../../common/components/FJImage/FJImage';
import FJUtil from '../../../../../../util/FJUtil';

const FJVideoPlayerPreview = props => {
    const { name, imgUrl, videoUrl, jumpLink } = props;

    const _video = useRef();
    const [isHover, setIsHover] = useState(false);

    const _onLoadedMetadata = () => {
        if (isHover && _video.current) {
            _video.current.play();
        }
    };

    const _onMouseEnter = () => {
        setIsHover(true);
    };

    const _onMouseLeave = () => {
        setIsHover(false);
    };

    const _onClick = () => {
        if (jumpLink) window.open(jumpLink, '_blank');
        FJUtil.eaLog('ai home ai tool page click', {
            toolName: name.replaceAll('-', ' '),
        });
    };

    return (
        <div className={CommonStyles.itemBox}>
            <div
                className={classNames(CommonStyles.previewBox, Styles.previewBox)}
                onMouseEnter={_onMouseEnter}
                onMouseLeave={_onMouseLeave}
                onClick={_onClick}
            >
                <FJImage imgSrc={imgUrl} alt='' reloadStyle={{ backgroundColor: '#FFF', zIndex: 3 }} />
                {isHover && (
                    <video ref={_video} src={videoUrl} loop={true} muted onLoadedMetadata={_onLoadedMetadata} />
                )}
            </div>
            <div className={CommonStyles.itemName}>{FJLocalStore._(name)}</div>
        </div>
    );
};

FJVideoPlayerPreview.propTypes = {
    name: PropTypes.string.isRequired,
    imgUrl: PropTypes.string.isRequired,
    videoUrl: PropTypes.string.isRequired,
    jumpLink: PropTypes.string.isRequired,
};

export default FJVideoPlayerPreview;
